import React, { useCallback, useState } from 'react';

import { Box, Button, Stack, TextField } from '@mui/material';

import { useUpdateBundleContent } from '~/hooks/apis/accommodation/useBundles';

import { Bundle } from '~/services/AccommodationService';

interface Props {
  bundle: Bundle;
}

export default function BundleContentSection({ bundle }: Props) {
  const [name, setName] = useState(bundle.name ?? '');

  const updateContentMutation = useUpdateBundleContent();

  const handleSave = useCallback(() => {
    updateContentMutation.mutate({
      bundleId: bundle.id,
      payload: { name },
    });
  }, [bundle.id, name, updateContentMutation]);

  const hasChanges = name !== bundle.name;

  return (
    <Stack spacing={3}>
      <TextField
        label="Bundle Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        size="small"
        fullWidth
        required
      />

      <Box>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={updateContentMutation.isPending || !name.trim() || !hasChanges}
        >
          {updateContentMutation.isPending ? 'Saving...' : 'Save Content'}
        </Button>
      </Box>
    </Stack>
  );
}
